import { Form, Input } from 'antd'

const StepOne = () => {
  return (
    <Form.Item
      label="Insira sua senha"
      name="password"
      rules={[{ required: true, message: 'Por favor, insira sua senha!' }]}
    >
      <Input.Password placeholder="Senha" />
    </Form.Item>
  )
}

export default StepOne
